import * as React from "react";
const SvgFiRrSkiBootSki = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-ski-boot-ski_svg__a)">
      <path
        fill="#062147"
        d="M4 14.5a1.5 1.5 0 1 1 3 .001 1.5 1.5 0 0 1-3 0M.882 18.532a4 4 0 0 1-.853-3.317c.163-.85.309-1.45.309-1.45L2.654 2.618A3.25 3.25 0 0 1 5.822.038h6.908a2.78 2.78 0 0 1 2.169 1.034c.532.658.736 1.51.56 2.338l-1.451 5.896 1.413.408a5.74 5.74 0 0 1 4.577 5.794v.49a3.98 3.98 0 0 1-1.171 2.83 3.97 3.97 0 0 1-2.83 1.171H4a4.03 4.03 0 0 1-3.118-1.467m1.54-1.274A2.04 2.04 0 0 0 4 18h11.998c.535 0 1.037-.208 1.415-.586s.585-.88.585-1.415v-.519c.053-1.862-1.214-3.453-3.013-3.813-.027-.006-2.32-.667-2.32-.667H8a1 1 0 1 1 0-2h4.024l.492-2H8.999a1 1 0 1 1 0-2h4.009l.502-2.037a.76.76 0 0 0-.166-.632.78.78 0 0 0-.614-.293H5.822a1.24 1.24 0 0 0-1.21.986L2.29 14.204c-.01.041-.145.6-.295 1.387a2.02 2.02 0 0 0 .429 1.667M23 18a1 1 0 0 0-1 1c0 1.654-1.346 3-3 3H1a1 1 0 1 0 0 2h18c2.757 0 5-2.243 5-5a1 1 0 0 0-1-1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-ski-boot-ski_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSkiBootSki;
